// extracted by mini-css-extract-plugin
export default {"mainText":"Users_mainText__FzrS9","btnCustom":"Users_btnCustom__SiQpS","page":"Users_page__z3VeE","inp":"Users_inp__diC0+"};